import colors from 'vuetify/lib/util/colors'

export default {
    light: {
        primary: '#194a7f',
        secondary: '#757575',
        accent: "#29abe2",
        bg_main: "#eee",

        //##### DASHBOARD TOP CARDS #####
        bg_home_card_1: '#f6931c',
        bg_home_card_1_avatar: '#f5881f',
        bg_home_card_1_title: '#f5a448',
        
        bg_home_card_2: '#28a9e2',
        bg_home_card_2_avatar: '#239cd3',
        bg_home_card_2_title: '#50b7e4',
        
        bg_home_card_3: '#f0605f',
        bg_home_card_3_avatar: '#f34d4f',
        bg_home_card_3_title: '#ef7b7c',
        
        bg_home_card_4: '#8dc73f',
        bg_home_card_4_avatar: '#72bc41',
        bg_home_card_4_title: '#a1cf62',

        //STATUS TEXT
        status_active: '#f15a25',
        status_process: '#239cd3',
        status_canceled: colors.pink.darken1,
        status_finished:  '#72bc41',

        //btn_download_invoice: colors.orange.lighten2,

        error: colors.red.lighten1,
        warning: colors.orange.lighten1,
    },

    icons:{
        //APP BAR
        logo_app_bar: 'img/logo_genl_blanco.png',
        icon_menu_burger: 'img/menu-burger.svg',
        icon_portfolio: 'img/maletin.svg',
        icon_search: 'img/lupa.svg',
        icon_notification: 'img/campana.svg',

        //###### DASHBOARD CARDS ICONS #####
        icon_home_card_1: 'img/pendiente_c.png',
        icon_home_card_2: 'img/proceso_c.png',
        icon_home_card_3: 'img/cancelado_c.png',
        icon_home_card_4: 'img/completado_c.png',

        // MAIN DRAWER NAVIGATION
        icon_new_process: 'img/1-icono-nuevo.svg',
        icon_new_process_selected: 'img/1-icono-nuevo-selected.svg',
        
        icon_all: 'img/2-icono-mistramites.svg',
        icon_all_selected: 'img/2-icono-mistramites-selected.svg',

        icon_pending: 'img/3-icono-pendientes.svg',
        icon_pending_selected: 'img/3-icono-pendientes-selected.svg',

        icon_in_process: 'img/4-icono-enproceso.svg',
        icon_in_process_selected: 'img/4-icono-enproceso-selected.svg',

        icon_canceled: 'img/5-icono-cancelados.svg',
        icon_canceled_selected: 'img/5-icono-cancelado-selecteds.svg',

        icon_finished: 'img/6-icono-completados.svg',
        icon_finished_selected: 'img/6-icono-completados-selected.svg',

        icon_orders: 'img/7-icono-misordenes.svg',
        icon_orders_selected: 'img/7-icono-misordenes-selected.svg',

        //PROCEDURES LIST
        icon_continue: 'img/continuar.png',
        icon_show_progress: 'img/progreso.png',

        //extras?
        estatus_pending: 'img/8-estatus-pendiente.svg',
        estatus_finished: 'img/9-estatus-completado.svg',
        estatus_on_process: 'img/10-estatus-enproceso.svg',
        estatus_see_more: 'img/11-estatus-vermas.svg',
        estatus_canceled: 'img/status-canceled.svg',

        facebook: 'img/i_facebook.webp',
        facebook_active: 'img/i_facebook_a.webp',
        instagram: 'img/i_instagram.webp',
        instagram_active: 'img/i_instagram_a.webp',
        telegram: 'img/i_telegram2.webp',
        telegram_active: 'img/i_telegram2_a.webp',
        twitter: 'img/i_twitter.webp',
        twitter_active: 'img/i_twitter_a.webp',
        youtube: 'img/i_youtube.webp',
        youtube_active: 'img/i_youtube_a.webp',
        whatsapp: 'img/i_whatsapp.webp',
        whatsapp_active: 'img/i_whatsapp_a.webp',
        terminos: 'img/terminos_y_condiciones-02.webp',
        aviso: 'img/aviso_de_privacidad.webp',

    }

}
